var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.view === "list",
              expression: "view==='list'"
            }
          ],
          staticClass: "main-content"
        },
        [
          _c("use-car-application-form-tab-list", {
            ref: "useCarApplicationFormTabList",
            attrs: { lob: _vm.lob, source: "useCarApplicationFormTab" },
            on: { batchGenerateCarFormHandle: _vm.batchGenerateCarFormHandle }
          })
        ],
        1
      ),
      _vm.view === "detail"
        ? _c("car-form-tab-detail", {
            ref: "carFormTabDetail",
            attrs: { lob: _vm.lob, source: "UseCarApplicationFormTab" },
            on: {
              cancel: function($event) {
                _vm.view = "list"
              },
              back: _vm.back
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }